import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { AppState } from '../../../../../types/store';
import { PostsType } from '../../../../../types/posts';
import { getPostsDeviationsStreamId } from '../../../../streams/posts';
import {
  selectors as streamSelectors,
  withOffset,
} from '@wix/da-shared-react/pkg/Stream';

import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { Props } from './Statuses';

type StateProps = Pick<Props, 'streamId' | 'items' | 'hasMore' | 'isFetching'>;
type DispatchProps = Pick<Props, 'fetchMore'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const statusesStreamId = getPostsDeviationsStreamId({
    type: PostsType.STATUSES,
    sortOrder: ownProps.sortOrder,
  });
  const statuses = getDeviationsByIds(
    state,
    streamSelectors.getItems(state, statusesStreamId)
  );

  return {
    streamId: statusesStreamId,
    items: statuses,
    hasMore: streamSelectors.hasMore(state, statusesStreamId),
    isFetching: streamSelectors.isFetching(state, statusesStreamId),
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  ownProps
) => {
  const statusesStreamId = getPostsDeviationsStreamId({
    type: PostsType.STATUSES,
    sortOrder: ownProps.sortOrder,
  });
  return {
    fetchMore: () => dispatch(withOffset.actions.fetch(statusesStreamId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps);
